import { Link } from '@mui/material'
import { useAppSelector } from '../../../../redux/store'
import { selectTasks } from '../slice'
import CompliancePlip from '../../../../components/CompliancePlip'
import { useMemo } from 'react'
import { nextDueDate } from '../../tasks/utils/helpers'
import { ComplianceStatus } from '../../../../types'
import { Task } from '../../tasks/types'
import dayjs from 'dayjs'

interface TasksProps {
  link: string
}

const Tasks = ({ link }: TasksProps) => {
  const tasks = useAppSelector(selectTasks)

  const isOverdue = (task: Task) => {
    const now = dayjs()
    const dueDate = dayjs(nextDueDate(task))
  
    if (dueDate.isBefore(now, 'day')) return true
    return false
  }

  const overDueTasks = useMemo(() => {
    return tasks?.filter((task) => task.active && isOverdue(task)) ?? []
  }, [tasks])

  const taskCount = useMemo(() => {
    return tasks?.filter((task) => task.active).length ?? 0
  }, [tasks])

  const upToDateTasks = useMemo(() => {
    return taskCount - overDueTasks.length
  }, [taskCount, overDueTasks])

  const complianceStatus = useMemo(() => {
    if (!overDueTasks.length && tasks?.length) return ComplianceStatus.green
    else if (overDueTasks.length) return ComplianceStatus.red
    else return ComplianceStatus.gray
  }, [tasks, overDueTasks])

  return tasks && (
    <>
      <div className='border-box'>
        <div>
          <CompliancePlip message='' className='dashboard-compliance' status={complianceStatus} />
        </div>
        <div className='compliance-message'>
          {complianceStatus === ComplianceStatus.green && (
            <p>You have upcoming tasks <Link href={link} className="text-info small-text"> View Details</Link></p>
          )}
          {complianceStatus === ComplianceStatus.red && (
            <p>This practice has overdue tasks <Link href={link} className="text-info small-text"> View Details</Link></p>
          )}
          {complianceStatus === ComplianceStatus.gray && (
            <p>This service is inactive <Link href={link} className="text-info small-text"> View Details</Link></p>
          )}
        </div>
      </div>
      <div className="card-footer flex justify-between">
        {tasks.length > 0 && (
          <div className="center-text">
            <span className="block text-ot-dashboard">{taskCount}</span>
            <span className="text-base">Task{tasks.length > 1 ? 's' : ''}</span>
          </div>
        )}
        {overDueTasks.length > 0 && (
          <div className="center-text">
            <span className="block text-ot-dashboard">{overDueTasks.length}</span>
            <span className="text-base"><CompliancePlip message='' className='dashboard-compliance small' status={complianceStatus} />Overdue</span>
          </div>
        )}
        {upToDateTasks > 0 && (
          <div className="center-text">
            <span className="block text-ot-dashboard">{upToDateTasks}</span>
            <span className="text-base">Up To Date</span>
          </div>
        )}
      </div>
    </>
  )
}

export default Tasks